<header
    class="events-hero"
    [class.has-image]="!!imageUrl"
    [class.compact]="compact"
    [style.--ev-accent]="accent">

    <div class="hero-bg" aria-hidden="true">
        <img *ngIf="imageUrl" [src]="imageUrl" alt="" loading="eager" decoding="async" />
        <div class="hero-tint"></div>
    </div>

    <div class="hero-inner">
        <p class="hero-eyebrow" *ngIf="eyebrow">{{ eyebrow }}</p>
        <h1 class="hero-title">{{ title }}</h1>
        <p class="hero-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
        <div class="hero-actions">
            <ng-content></ng-content>
        </div>
    </div>

    <svg class="hero-wave" viewBox="0 0 1440 90" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,52 C240,92 480,12 720,32 C960,52 1200,92 1440,62 L1440,90 L0,90 Z"></path>
    </svg>
</header>
